export const formatDateTime = (value: string | null | undefined) =>
  value ? new Date(value).toLocaleString() : '—';

export const timeAgo = (value: string | null | undefined) => {
  if (!value) return '—';
  const seconds = Math.round((Date.now() - new Date(value).getTime()) / 1000);
  if (seconds < 60) return 'just now';
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 48) return `${hours}h ago`;
  return `${Math.round(hours / 24)}d ago`;
};

export const timeUntil = (value: string | null | undefined) => {
  if (!value) return '—';
  const minutes = Math.round((new Date(value).getTime() - Date.now()) / 60000);
  if (minutes <= 0) return 'now';
  if (minutes < 60) return `in ${minutes}m`;
  const hours = Math.floor(minutes / 60);
  return hours < 48 ? `in ${hours}h ${minutes % 60}m` : `in ${Math.round(hours / 24)}d`;
};

export const formatDuration = (minutes: number) => {
  if (minutes < 60) return `${minutes} min`;
  const hours = minutes / 60;
  return Number.isInteger(hours) ? `${hours} h` : `${hours.toFixed(1)} h`;
};

export const providerLabel = (provider: string | null | undefined) =>
  provider ? provider.charAt(0).toUpperCase() + provider.slice(1) : '—';

export const EVENT_LABELS: Record<string, string> = {
  issue: 'Token issued',
  refresh: 'Token refreshed',
  revoke: 'Session revoked',
};
